import { createAction } from 'typesafe-actions'

export const setLoader = createAction('SET_LOADER_ACTIVE')<boolean>()
